import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldSelectComponent } from './field-select.component';
import { FormsModule } from '@angular/forms';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { DurationTextModule } from '../../duration-text';
import { MatChipsModule } from '@angular/material/chips';
import { NgxVisibilityModule } from 'ngx-visibility';


@NgModule({
  declarations: [
    FieldSelectComponent
  ],
  exports: [
    FieldSelectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CardComponent,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    DurationTextModule,
    MatChipsModule,
    NgxVisibilityModule
  ]
})
export class FieldSelectModule { }
